import React from 'react';
import {Button,Container, Row, Col} from 'reactstrap'
import {useHistory} from 'react-router-dom'
import {SignIn} from '../../actions/msal'



function LandingPage (){
  const history =useHistory()
  return(
    <Container fluid className="p-h-0 p-v-20 bg full-height d-flex landing-layout">
      <div className="d-flex flex-column justify-content-between w-100">
        <Container className="d-flex h-100">
          <Row className="align-items-center w-100">
            <Col md={6} lg={6} className="m-h-auto" >
              <Button color="primary" size="lg" block onClick={()=>
                SignIn(history)
              }>
                Đăng nhập với tài khoản Office 365
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
        
    </Container>
    
  )
}

export default LandingPage


// WEBPACK FOOTER //
// ./src/components/layout/Landing.js